import { Form, Radio } from 'antd';
import React from 'react';
import { ReactComponent as Google } from '../../../../assets/svg/icons/google-icon.svg';
import { concatClsx } from '../../../../helpers/classNames';
import { FORM_TYPES_KEYS } from '../../constants/Auth';
export var AuthTypeButtons = function (_a) {
    var className = _a.className;
    console.log("HOT");
    var type = window.location.href.includes('sign-up') ? 'sign-up' : 'sign-in';
    var getButtonContent = function (value) {
        switch (value) {
            case FORM_TYPES_KEYS.EMAIL:
                return type === 'sign-up' ? 'Sign up with email' : 'Sign in with email';
            case FORM_TYPES_KEYS.GOOGLE:
                return type === 'sign-up' ? 'Sign up with Google' : 'Sign in with Google';
            case FORM_TYPES_KEYS.UNI_ACCOUNT:
                return type === 'sign-up' ? 'Continue with university account' : 'Continue with university account';
            default:
                return '';
        }
    };
    return (React.createElement(Form.Item, { name: 'radio' },
        React.createElement(Radio.Group, { buttonStyle: "solid", className: "auth-select" },
            React.createElement(Radio.Button, { value: 'email', className: concatClsx('auth-select-button', className) },
                React.createElement("p", null, getButtonContent(FORM_TYPES_KEYS.EMAIL))),
            React.createElement(Radio.Button, { value: 'google', className: concatClsx('auth-select-button', className) },
                React.createElement("div", { className: "flex items-center justify-center" },
                    React.createElement(Google, null),
                    React.createElement("p", { className: "pl-2" }, getButtonContent(FORM_TYPES_KEYS.GOOGLE)))),
            React.createElement(Radio.Button, { value: 'uni-account', className: concatClsx('auth-select-button', className) },
                React.createElement("p", null, getButtonContent(FORM_TYPES_KEYS.UNI_ACCOUNT))))));
};
